// **********************************************************
// Product Gallery Modal
// **********************************************************

const productGalleryModalMain = document.querySelectorAll('[data-slider="product-gallery-modal-main-slider"]');
const productGalleryModalThumb = document.querySelectorAll('[data-slider="product-gallery-modal-thumb-slider"]');

const toggleProductGalleryModal = (element, toggle) => {
  const parentElement = element.closest('.product-gallery-modal');
  parentElement?.classList.toggle('is-open-modal', toggle);
  toggleBodyScrollLock(toggle);
};

// 1.1 - Product Gallery Thumb Slider
const productGalleryModalThumbSliderOptions = {
  direction: 'vertical',
  slidesPerView: 'auto',
  spaceBetween: 6,
  watchOverflow: true,
  allowTouchMove: false,
};

productGalleryModalThumb.forEach((ele) => new Swiper(ele, productGalleryModalThumbSliderOptions));

// 1.2 -Product Gallery Main Slider
const productGalleryModalMainOptions = {
  direction: 'vertical',
  slidesPerView: 'auto',
  spaceBetween: 60,
  grabCursor: true,
  simulateTouch: true,
  freeMode: true,
  mousewheel: true,
  breakpoints: {
    1023: {
      slidesPerView: 'auto',
      spaceBetween: 80,
      freeMode: false,
    },
  },
};

const initProductGalleryModalMainSlider = (el) => {
  const parent = el.closest('.product-gallery-modal');
  const thumbEl = parent.querySelector('[data-slider="product-gallery-modal-thumb-slider"]');

  new Swiper(el, {
    ...productGalleryModalMainOptions,
    thumbs: { swiper: thumbEl?.swiper || false, autoScroll: false },
    on: {
      slideChange: ({ realIndex }) => {
        const active = thumbEl?.querySelectorAll('.swiper-slide')[realIndex];
        if (!active) return;
        thumbEl.scrollTo({
          top: active.offsetTop - (thumbEl.clientHeight - active.offsetHeight) / 2,
          behavior: 'smooth',
        });
      },
    },
  });
};

// Initialize main sliders responsively (setupResponsiveSliders will handle resize/destroy)
setupResponsiveSliders({
  sliderElements: productGalleryModalMain,
  breakpoint: breakpointMd,
  initSlider: initProductGalleryModalMainSlider,
  mobileFallback: () => {},
  parentSelector: '[product-gallery-parent] .product-gallery-modal',
});

// Attach delegated click handler once (avoid adding multiple listeners in a loop)
attachEvent('[data-modal-slide]', 'click', (ev) => {
  const targetSlideEle = ev.target.closest('.product-showcase__image');
  if (!targetSlideEle) return;

  const targetSlideAttr = targetSlideEle.getAttribute('data-modal-slide');
  const parentEle = targetSlideEle.closest('[product-gallery-parent]');
  const galleryModal = parentEle.querySelector('.product-gallery-modal');
  const slideIndex = Number(targetSlideAttr) - 1;

  if (galleryModal) {
    galleryModal.classList.add('is-open-modal');
    toggleBodyScrollLock(true);
  }

  if (windowWidth() > breakpointMd) {
    const mainSliderEl = galleryModal.querySelector('[data-slider="product-gallery-modal-main-slider"]');
    if (mainSliderEl?.swiper) {
      mainSliderEl.swiper.slideTo(slideIndex, 0);
    }
    return;
  }

  const modalSlides = parentEle.querySelectorAll('.product-gallery-modal__main .swiper-slide');
  const mobileTargetSlide = modalSlides[slideIndex];

  if (galleryModal && mobileTargetSlide) {
    galleryModal.scrollTo({
      top: mobileTargetSlide.offsetTop,
      behavior: 'smooth',
    });
  }
});

// **********************************************************
// 1.3 Product Gallery Modal When Escape Key Press
// **********************************************************

onKeydown('escape', () => {
  document.querySelectorAll('.product-gallery-modal.is-open-modal').forEach((el) => {
    toggleProductGalleryModal(el, false);
  });
});

// **********************************************************
// 1.4 Product Gallery Modal When Click On Close
// **********************************************************

attachEvent('.product-gallery-modal__close', 'click', (ev) => {
  toggleProductGalleryModal(ev.target, false);
});
